import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:localStorage.getItem("token") || ''
  },
  mutations: {
    //同步修改state里面的值
    SET_TOKEN:(state,token)=>{
      state.token=token
    }
  },
  //异步调用mutations
  //context.commit利用上下文触发mutations某个方法
  //vue代码里使用this.$store.despatch出触发action里面定义的方法
  actions: {
    setToken(context,token){
      context.commit('SET_TOKEN',token)
    },
    clearToken(context){
      context.commit('SET_TOKEN','')
    }
  },
  modules: {
  }
})
